import { app } from './conn.js';
import { getFirestore } from "firebase/firestore";

export const db = getFirestore(app);